import { FC } from "react";
import { Button, Modal, Text, Title } from "rizzui";
import TrashIcon from "@/components/icons/trash";

interface DeleteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  userName?: string;
}

const DeleteUserModal: FC<DeleteUserModalProps> = ({
  isOpen,
  onClose,
  onDelete,
  userName,
}) => {
  const handleDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
            <TrashIcon className="h-5 w-5 text-red-500" />
          </div>
          <Title as="h3" className="text-lg font-semibold">
            Delete User
          </Title>
        </div>

        <Text className="mb-6 text-gray-600">
          Are you sure you want to delete{" "}
          {userName ? (
            <>
              user <strong>{userName}</strong>
            </>
          ) : (
            "this user"
          )}
          ? This action cannot be undone.
        </Text>

        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button color="danger" onClick={handleDelete}>
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteUserModal;
